'use client';
import { createContext } from 'react';
import type { DependencyGraphContextType } from './types';

export const ENTITY_OVERRIDES = '__entityOverrides__';

export enum PAGE_FIELD_KEYS_TO_TRACK {
  DOCUMENT_TITLE = 'documentTitle',
}

export const DependencyGraphContext = createContext<DependencyGraphContextType | null>(null);
export const AppDependencyGraphContext = createContext<DependencyGraphContextType | null>(null);
